import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {IRecursoDetalhesDto} from "@components/recurso/models/dto/IRecursoDetalhesDto.ts";
import {IRecursoParamDto} from "@components/recurso/models/dto/IRecursoParamDto.ts";

export const __recurso_endpoints = {
	['v2']: {
		['get-detalhes']: (data: IDataNoPageDto<{ recursoId: number }>): IApiEndpoint<IRecursoDetalhesDto> => {
			return {
				url: `/api/v2/Recursos/${data.data.recursoId}/detalhes`,
				method: 'GET',
				data: data,
			}
		},
		['get-parametros']: (data: IDataDto<{ recursoId: number }>): IApiEndpoint<IRecursoParamDto[]> => {
			const {recursoId, ...rest} = data.data
			return {
				url: `/api/v2/Recursos/${recursoId}/parametros`,
				method: 'GET',
				data: {...data, data: {...rest}},
			}
		},
		['update-parametros']: (data: IDataNoPageDto<{
			recursoId: number,
			parametros: IRecursoParamDto[]
		}>): IApiEndpoint<IRecursoParamDto[]> => {
			const {data: {recursoId, parametros}} = data

			return ({
				url: `/api/v2/Recursos/${recursoId}/parametros`,
				method: 'PATCH',
				data: {...data, data: [...parametros]},
			})
		}
	}
}